import type { ClipboardEvent, KeyboardEvent } from 'react';

/** Prevents typing `-` and `e` in number inputs */
const preventNegativeKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.key === '-' || e.key === 'e') {
    e.preventDefault();
  }
};

/** Prevents pasting values containing `-` or `e` */
const preventNegativePaste = (e: ClipboardEvent<HTMLInputElement>) => {
  const pastedText = e.clipboardData.getData('text');
  if (pastedText.includes('-') || pastedText.toLowerCase().includes('e')) {
    e.preventDefault();
  }
};

/** Spread these props onto any `<Input type="number">` that must be non-negative */
export const nonNegativeInputProps = {
  min: 0,
  onKeyDown: preventNegativeKeyDown,
  onPaste: preventNegativePaste,
} as const;
